import { Search } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

const MobileHeader = ({
  children,
  showSearch,
}: {
  children: React.ReactNode;
  /** Compact search → contacts list (desktop Header parity). */
  showSearch?: boolean;
}) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-10 bg-secondary/95 backdrop-blur-md supports-[backdrop-filter]:bg-secondary/90 border-b border-border/60 h-14 px-4 w-full flex justify-between items-center gap-2">
      <div className="flex items-center gap-2 min-w-0 flex-1">{children}</div>
      {showSearch ? (
        <Button
          asChild
          variant="ghost"
          size="icon"
          className="h-9 w-9 shrink-0 text-secondary-foreground"
          aria-label="Search contacts"
        >
          <Link to="/contacts">
            <Search className="size-5" />
          </Link>
        </Button>
      ) : null}
    </header>
  );
};

export default MobileHeader;
